import Vue from 'vue'

import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../../../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'

/* Plugins */

import nuxt_plugin_plugin_7b5c189b from 'nuxt_plugin_plugin_7b5c189b' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_plugin_238c6933 from 'nuxt_plugin_plugin_238c6933' // Source: ./vuetify/plugin.js (mode: 'all')
import nuxt_plugin_image_3349112c from 'nuxt_plugin_image_3349112c' // Source: ./image.js (mode: 'all')
import nuxt_plugin_plugin_ab3520c4 from 'nuxt_plugin_plugin_ab3520c4' // Source: ./nuxt-speedkit/plugin.js (mode: 'all')
import nuxt_plugin_vuesocialsharingplugin_8d8766ac from 'nuxt_plugin_vuesocialsharingplugin_8d8766ac' // Source: ./vue-social-sharing-plugin.js (mode: 'all')
import nuxt_plugin_pluginclient_54cbc2d2 from 'nuxt_plugin_pluginclient_54cbc2d2' // Source: ./content/plugin.client.js (mode: 'client')
import nuxt_plugin_pluginserver_3b53901f from 'nuxt_plugin_pluginserver_3b53901f' // Source: ./content/plugin.server.js (mode: 'server')
import nuxt_plugin_httpserver_8d0cbf44 from 'nuxt_plugin_httpserver_8d0cbf44' // Source: ./http.server.js (mode: 'server')
import nuxt_plugin_http_5cff9802 from 'nuxt_plugin_http_5cff9802' // Source: ./http.js (mode: 'all')
import nuxt_plugin_workbox_7c437de6 from 'nuxt_plugin_workbox_7c437de6' // Source: ./workbox.js (mode: 'client')
import nuxt_plugin_metaplugin_a63fa9c0 from 'nuxt_plugin_metaplugin_a63fa9c0' // Source: ./pwa/meta.plugin.js (mode: 'all')
import nuxt_plugin_iconplugin_9cf05ed8 from 'nuxt_plugin_iconplugin_9cf05ed8' // Source: ./pwa/icon.plugin.js (mode: 'all')
import nuxt_plugin_aftereach_071c8daf from 'nuxt_plugin_aftereach_071c8daf' // Source: ../../../plugins/after-each.js (mode: 'client')
import nuxt_plugin_truncate_eecc2cca from 'nuxt_plugin_truncate_eecc2cca' // Source: ../../../plugins/truncate.js (mode: 'all')
import nuxt_plugin_vuecheckview_535e18b0 from 'nuxt_plugin_vuecheckview_535e18b0' // Source: ../../../plugins/vue-check-view.js (mode: 'client')
import nuxt_plugin_imagine_3bfbd6d7 from 'nuxt_plugin_imagine_3bfbd6d7' // Source: ../../../plugins/imagine.js (mode: 'all')
import nuxt_plugin_checkScreenPlugin_f024e862 from 'nuxt_plugin_checkScreenPlugin_f024e862' // Source: ../../@luaguillande/screen-checker/checkScreenPlugin.js (mode: 'all')
import nuxt_plugin_event_03aa4e93 from 'nuxt_plugin_event_03aa4e93' // Source: ../../../plugins/event.js (mode: 'client')
import nuxt_plugin_mask_18e26f55 from 'nuxt_plugin_mask_18e26f55' // Source: ../../../plugins/mask.js (mode: 'client')
import nuxt_plugin_axios_5659d192 from 'nuxt_plugin_axios_5659d192' // Source: ../../../plugins/axios.js (mode: 'client')
import nuxt_plugin_pixel_2ae051b2 from 'nuxt_plugin_pixel_2ae051b2' // Source: ../../../plugins/pixel.js (mode: 'client')
import nuxt_plugin_pixelgestaouniversitaria_33ca9646 from 'nuxt_plugin_pixelgestaouniversitaria_33ca9646' // Source: ../../../plugins/pixel-gestao-universitaria.js (mode: 'client')
import nuxt_plugin_gtag_0a2cb1e4 from 'nuxt_plugin_gtag_0a2cb1e4' // Source: ../../../plugins/gtag.js (mode: 'client')
import nuxt_plugin_orange_6ee1b35a from 'nuxt_plugin_orange_6ee1b35a' // Source: ../../../plugins/orange.js (mode: 'client')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root.$options.$nuxt
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"layout","mode":"","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext, config)

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"titleTemplate":"%s","title":"Multiversa","charset":"utf-8","htmlAttrs":{"lang":"pt"},"meta":[{"charset":"utf-8"},{"http-equiv":"Content-Type","content":"text\u002Fhtml; charset=UTF-8"},{"http-equiv":"Content-Security-Policy","content":"default-src 'self' 'unsafe-inline' data: blob: wss: https:\u002F\u002F*.luckyorange.com\u002F https:\u002F\u002Fneoperspectiva.com.br\u002F  https:\u002F\u002Fgyruss.rdops.systems https:\u002F\u002Fi.ytimg.com\u002F https:\u002F\u002Fwww.youtube.com\u002F https:\u002F\u002Fwww.google-analytics.com\u002F https:\u002F\u002Funpkg.com\u002F https:\u002F\u002Fcdnjs.cloudflare.com\u002F https:\u002F\u002Fwww.googletagmanager.com\u002F https:\u002F\u002Fcdn.priv.center\u002F https:\u002F\u002Fconnect.facebook.net\u002F https:\u002F\u002F*.cloudfront.net\u002F https:\u002F\u002F*.googleapis.com\u002F https:\u002F\u002Fcdn.jsdelivr.net\u002F https:\u002F\u002F*.truendo.com\u002F https:\u002F\u002F*.luckyorange.net\u002F https:\u002F\u002F*.rdstation.com.br\u002F https:\u002F\u002Fik.imagekit.io\u002F https:\u002F\u002Ffonts.gstatic.com\u002F https:\u002F\u002Fcdn.jsdelivr.net\u002F https:\u002F\u002Fwww.facebook.com\u002F https:\u002F\u002Fwww.google.com\u002F"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"name":"format-detection","content":"telephone=no"},{"name":"facebook-domain-verification","content":"nd652ebzu6en9ftwkowzynmt0ie35j"},{"name":"theme-color","content":"#2d386d"}],"link":[{"rel":"manifest","type":"json","href":"\u002Fmanifest.json"},{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.png"},{"rel":"preconnect","href":"https:\u002F\u002Ffonts.googleapis.com"},{"rel":"preconnect","href":"https:\u002F\u002Ffonts.gstatic.com"},{"rel":"preconnect","href":"https:\u002F\u002Funpkg.com"},{"rel":"preconnect","href":"https:\u002F\u002Fcdnjs.cloudflare.com"},{"rel":"preconnect","href":"https:\u002F\u002Fcdn.jsdelivr.net"},{"rel":"preload","as":"style","onload":"this.rel='stylesheet'","href":"https:\u002F\u002Funpkg.com\u002Faos@2.3.1\u002Fdist\u002Faos.css","ssr":false,"defer":true},{"rel":"stylesheet","href":"https:\u002F\u002Fcdnjs.cloudflare.com\u002Fajax\u002Flibs\u002Ffont-awesome\u002F6.1.1\u002Fcss\u002Fall.min.css","defer":true,"async":true,"ssr":false},{"rel":"stylesheet","href":"https:\u002F\u002Fcdnjs.cloudflare.com\u002Fajax\u002Flibs\u002Fflickity\u002F2.2.0\u002Fflickity.min.css","ssr":false},{"rel":"stylesheet","type":"text\u002Fcss","href":"https:\u002F\u002Ffonts.googleapis.com\u002Fcss?family=Roboto:100,300,400,500,700,900&display=swap"},{"rel":"stylesheet","type":"text\u002Fcss","href":"https:\u002F\u002Fcdn.jsdelivr.net\u002Fnpm\u002F@mdi\u002Ffont@latest\u002Fcss\u002Fmaterialdesignicons.min.css"}],"script":[{"src":"https:\u002F\u002Funpkg.com\u002Faos@2.3.1\u002Fdist\u002Faos.js","defer":true,"ssr":false},{"src":"https:\u002F\u002Fcdnjs.cloudflare.com\u002Fajax\u002Flibs\u002Fflickity\u002F2.2.0\u002Fflickity.pkgd.min.js","ssr":false},{"src":"https:\u002F\u002Fd335luupugsy2.cloudfront.net\u002Fjs\u002Floader-scripts\u002F357c66e2-a55d-430b-a726-b0a95d215d25-loader.js","defer":true,"body":true},{"src":"https:\u002F\u002Fd335luupugsy2.cloudfront.net\u002Fjs\u002Frdstation-forms\u002Fstable\u002Frdstation-forms.min.js","defer":true,"body":true},{"src":"https:\u002F\u002Fwww.googletagmanager.com\u002Fgtag\u002Fjs?id=UA-228576147-1","defer":true},{"src":"https:\u002F\u002Fcdn.priv.center\u002Fpc\u002Ftruendo_cmp.pid.js","data-siteid":"29725c49-bdd0-463a-9407-5752fa137d40","defer":true,"async":true,"ssr":false,"id":"truendoAutoBlock","body":true}],"style":[]},

    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_7b5c189b === 'function') {
    await nuxt_plugin_plugin_7b5c189b(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_238c6933 === 'function') {
    await nuxt_plugin_plugin_238c6933(app.context, inject)
  }

  if (typeof nuxt_plugin_image_3349112c === 'function') {
    await nuxt_plugin_image_3349112c(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_ab3520c4 === 'function') {
    await nuxt_plugin_plugin_ab3520c4(app.context, inject)
  }

  if (typeof nuxt_plugin_vuesocialsharingplugin_8d8766ac === 'function') {
    await nuxt_plugin_vuesocialsharingplugin_8d8766ac(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_pluginclient_54cbc2d2 === 'function') {
    await nuxt_plugin_pluginclient_54cbc2d2(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_pluginserver_3b53901f === 'function') {
    await nuxt_plugin_pluginserver_3b53901f(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_httpserver_8d0cbf44 === 'function') {
    await nuxt_plugin_httpserver_8d0cbf44(app.context, inject)
  }

  if (typeof nuxt_plugin_http_5cff9802 === 'function') {
    await nuxt_plugin_http_5cff9802(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_workbox_7c437de6 === 'function') {
    await nuxt_plugin_workbox_7c437de6(app.context, inject)
  }

  if (typeof nuxt_plugin_metaplugin_a63fa9c0 === 'function') {
    await nuxt_plugin_metaplugin_a63fa9c0(app.context, inject)
  }

  if (typeof nuxt_plugin_iconplugin_9cf05ed8 === 'function') {
    await nuxt_plugin_iconplugin_9cf05ed8(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_aftereach_071c8daf === 'function') {
    await nuxt_plugin_aftereach_071c8daf(app.context, inject)
  }

  if (typeof nuxt_plugin_truncate_eecc2cca === 'function') {
    await nuxt_plugin_truncate_eecc2cca(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuecheckview_535e18b0 === 'function') {
    await nuxt_plugin_vuecheckview_535e18b0(app.context, inject)
  }

  if (typeof nuxt_plugin_imagine_3bfbd6d7 === 'function') {
    await nuxt_plugin_imagine_3bfbd6d7(app.context, inject)
  }

  if (typeof nuxt_plugin_checkScreenPlugin_f024e862 === 'function') {
    await nuxt_plugin_checkScreenPlugin_f024e862(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_event_03aa4e93 === 'function') {
    await nuxt_plugin_event_03aa4e93(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_mask_18e26f55 === 'function') {
    await nuxt_plugin_mask_18e26f55(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_axios_5659d192 === 'function') {
    await nuxt_plugin_axios_5659d192(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_pixel_2ae051b2 === 'function') {
    await nuxt_plugin_pixel_2ae051b2(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_pixelgestaouniversitaria_33ca9646 === 'function') {
    await nuxt_plugin_pixelgestaouniversitaria_33ca9646(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_gtag_0a2cb1e4 === 'function') {
    await nuxt_plugin_gtag_0a2cb1e4(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_orange_6ee1b35a === 'function') {
    await nuxt_plugin_orange_6ee1b35a(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    app,
    router
  }
}

export { createApp, NuxtError }
